import { useField } from "formik";
import React from "react";
import { DeleteButton } from "../../../button/Delete.Button";
import { DurationTimestamp } from "../../../calendar/Calendar.model";
import { FormikHelpers } from "../../../helpers/Formik.Helpers";
import { DatePickerPlain } from "./DatePickerPlain";
import { FormikInputParams } from "./FormikInputParams.model";

interface DurationTimestampInputProps extends FormikInputParams {
  onDelete?: () => void;
}

export function DurationTimestampFormikInput(
  props: DurationTimestampInputProps
) {
  const [field] = useField(props);
  const currentValue = () => {
    return field.value;
  };

  const onChange = (v?: any) => {
    FormikHelpers.updateField(field, props.name, v);
  };

  return (
    <DurationTimestampPlainInput
      value={currentValue()}
      onChange={onChange}
      onDelete={props.onDelete}
      disabled={props.disabled}
    />
  );
}

interface DurationTimestampPlainProps {
  value?: DurationTimestamp;
  onChange: (v?: DurationTimestamp) => void;
  onDelete?: () => void;
  disabled?: boolean;
}

export function DurationTimestampPlainInput(
  props: DurationTimestampPlainProps
) {
  const onFromChange = (ms?: number | null) => {
    const fromMillis = ms != null ? ms : undefined;
    const toMillis = props.value?.toMillis ? props.value.toMillis : undefined;
    const newVal =
      fromMillis || toMillis ? { fromMillis, toMillis } : undefined;
    props.onChange(newVal as DurationTimestamp | undefined);
  };

  const onToChange = (ms?: number | null) => {
    const toMillis = ms != null ? ms : undefined;
    const fromMillis = props.value ? props.value.fromMillis : undefined;
    const newVal =
      fromMillis || toMillis ? { fromMillis, toMillis } : undefined;
    props.onChange(newVal as DurationTimestamp | undefined);
  };

  return (
    <div className="DurationTimestampEditComponent">
      <div className="row">
        <div className="col">
          <div>
            <DatePickerPlain
              value={props.value ? props.value.fromMillis : undefined}
              onChange={onFromChange}
              className="form-control"
              placeholder={"From"}
              disabled={props.disabled}
            />
          </div>
          <div className="pt-2">
            <DatePickerPlain
              value={props.value ? props.value.toMillis : undefined}
              onChange={onToChange}
              className="form-control"
              placeholder={"Until"}
              disabled={props.disabled}
            />
          </div>
        </div>
        {props.onDelete && (
          <div className="col-auto">
            <DeleteButton onClick={props.onDelete} />
          </div>
        )}
      </div>
    </div>
  );
}
